import { extractPersonFromJsonLd } from './index';
export const extractPersonOwnedBy = jsonLd => {
  const ownedBy = jsonLd['atlassian:ownedBy'];
  if (ownedBy) {
    if (Array.isArray(ownedBy)) {
      return ownedBy.map(extractPersonFromJsonLd).filter(item => !!item);
    } else {
      const item = extractPersonFromJsonLd(ownedBy);
      if (item) {
        return [item];
      }
    }
  }
};